import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { selectActiveDeliverable, selectSelectedDeliverables } from 'store/selectors/deliverableSelectors';
import useBaseLineOrderWorkunitApi from '../ChangeBaselinePages/services/useBaseLineOrderWorkunitApi';
import { filterTotalFlagAction } from 'store/actions/changeBaselineActions';
// import useDeliverableService from '../../hooks/useDeliverableService';

const DeliverableBLDialogDelete: React.FC = () => {
  const [t] = useTranslation();

  // const { deleteDeliverables } = useDeliverableService();
  const { dispatch } = useAppState();
  const changeBaseline = useSelector((state) => state.changeBaseline);
  const { EditTotalBaseLineWorkunit } = useBaseLineOrderWorkunitApi();
  // const selectedDeliverables = useSelector(selectSelectedDeliverables);
  // const activeDeliverable = useSelector(selectActiveDeliverable);
  // const deliverables = activeDeliverable ? [activeDeliverable] : selectedDeliverables;
  const dialogs = useSelector((state) => state.dialogs);
  const data = dialogs?.data;
  const close = () => {
    dispatch(closeDialogAction('deliverableBaseLineDelete'));
  };
  const remove = async () => {
    // const orderWorkunitsIds = deliverables.map((orderWorkunit) => orderWorkunit.id);
    // deleteDeliverables(orderWorkunitsIds);
    const res = await EditTotalBaseLineWorkunit(
      Number(changeBaseline?.baseLineOrder?.id),
      data,
      Number(changeBaseline?.sourceOrder?.id)
    );
    if (res) {
      dispatch(filterTotalFlagAction(true));
      close();
    }
  };

  return (
    <>
      <Dialog style={{ maxHeight: 435 }} maxWidth="xs" open={dialogs.deliverableBaseLineDelete || false}>
        <DialogTitle>{t('Delete deliverables')}</DialogTitle>
        <DialogContent>
          <div>{t('Confirm_Delete_Deliverables')}</div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={close}>
            {t('Cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={remove}>
            {t('Delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeliverableBLDialogDelete;
